export default __webpack_public_path__ + "static/media/ods13.9389d233.svg";